if ($('#MakeItAMeal').length) {
    var currentUrl = $('#backLinkUrl').attr('href');
    var makeItAMealInit = function () {
        //initialize array of selected items
        var selectedArrayOneDrink = [];
        var selectedArrayOneSide = [];
        var selectedArrayTwoSides = [];
        var selectedArrayThreeSides = [];

        // set initial dropdown values to preselected Drink and Side(s)
        var selectedDrink = $('#SelectedDrink').val();
        var selectedSide1 = $('#selectedSide1').val();
        var selectedSide2 = $('#selectedSide2').val();
        function isOpen(dropdown) {
            return !$(dropdown).hasClass('hide-remove');
        }

        $(document).ready(function () {
            $('.category-details').css({ "height": "173px" });
            if ($(window).width() < 1024) { $('.category-details').css({ "height": "152px" }); }
            setTimeout(function () {
                if ($(".selected").length > 0) {
                    if ($("button").hasClass("selected")) {
                        $(".selected").each(function () {
                            $(this).closest('.category-details').find('.pickup-info').removeClass('hide-remove');
                            var categoryContentHeight = $(this).closest('.category-details').find('.category-image').height() + $(this).closest('.category-content').height() + 18;
                            $(this).closest('.category-details').css("height", categoryContentHeight + 'px');
                        });
                    }
                }
            }, 100);
            $('.draggable-list li').on('click keydown', function (e) {
                if (e.which === keyCodes.RETURN || e.type === 'click') {
                    //if the dropdown is a drinks dropdown
                    if ($(this).parent().hasClass('drinks-dropdown')) {

                        //gets id of the card
                        var cardID = $(this).attr('id').split('-')[1];
                        var cardSelector = '#' + cardID;

                        var $form = $('#frmMakeItAMeal');
                        //var action = $form.attr('action');
                        var route = '/RemoteOrder/Menu/MakeItAMealSidesAsync';
                        // var action = $form.attr('action');
                        //var triggerSelector = '#trigger-' + cardID;
                        var triggerSelector = $(this).attr('data-choice-id');
                        //  var selectedOptId = $(triggerSelector).attr('data-combo-option-id');
                        void 0;
                        subwayScript.showSpinner();
                        $('#selectedComboOptionId').val(triggerSelector);
                        ajaxGetResults(route, 'frmMakeItAMeal');

                        function ajaxGetResults(route, formId) {

                            $.ajax({
                                url: route,
                                type: 'POST',
                                data: $('#' + formId).serialize(),
                                success: function (data) {

                                    $('#MakeItMealSides').html(data);
                                    $('#MakeItMealSides').show();
                                    pageActions();
                                    if ($('#SelectedDrinkSides').val() === undefined || $('#SelectedDrinkSides').val() === null || $('#SelectedDrinkSides').val() === '' ) {
                                        $('.btn-meal-done').prop('disabled', true).attr('aria-disabled', 'true').removeClass('hide-remove');
                                    }
                                    else {
                                        $('.btn-meal-done').removeAttr('disabled').attr('aria-disabled', 'false').removeClass('hide-remove');
                                    }
                                },
                                error: function (jqXhr) {
                                    modalClose(true);
                                    subwayScript.hideSpinner();
                                    var errModel = subwayScript.showAjaxError(jqXhr, true);
                                },
                                complete: function (data) {
                                    subwayScript.hideSpinner();
                                }
                            });
                        }


                        //gets the value of the selected item and stores it in a variable
                        var selectedItem = $(this).attr('data-item');
                        if (typeof $(this).attr('data-price') !== "undefined") {
                            var selectedPrice = $(this).attr('data-price');
                        } else {
                            var selectedPrice = '';
                        }
                        var selectedCals = $(this).attr('data-calories');
                        var selectedText = '<span class="select-text-container"><span class="selected-drink">' + selectedItem + '</span>' + ' | ' + selectedPrice + ' ' + selectedCals + '</span>';
                        var selectedValue = $(this).attr('data-item-value');
                        var selectedIsOption = $(this).attr('data-IsOption');
                        var selectedChoiceId = $(this).attr('data-choice-id');
                        var selectedCookieId = $(this).attr('data-cookie-id');
                        var selectedCookieName = $(this).attr('data-cookie-name');

                        //finds value of dropdown trigger and sets it to whatever the selected item value is
                        var triggerSelector = '#trigger-' + cardID;
                        $(triggerSelector).html(selectedText);
                        selectedArrayOneDrink.splice(0, 1, selectedItem);
                        $(triggerSelector).attr('data-selected-value', selectedValue); //optionId
                        $(triggerSelector).attr('aria-label', selectedItem + ' ' + selectedCals + ' Selected');
                        $(triggerSelector).attr('data-option-name', selectedItem); //optionValue
                        $(triggerSelector).attr('data-isoption', selectedIsOption); //IsOption
                        $(triggerSelector).attr('data-choiceid', selectedChoiceId); //choiceId
                        $(triggerSelector).attr('data-cookieid', selectedCookieId);
                        $(triggerSelector).attr('data-cookiename', selectedCookieName);

                        //hides list and overlay after an item is selected
                        $('.dragdealer, .overlay-time-list').addClass('hide-remove');
                        // $(triggerSelector).closest('.category-details').find('.dragdealer').find('li').attr('tabindex', 0);
                        setTimeout(function () { $(triggerSelector).focus(); }, 100);

                        $('.selected-item-name').html(selectedItem + '<span class="icon icon-expand_less desktop-exit"></span>');
                        $('.drinks-dropdown li').each(function () {
                            if ($(this).data('item') == selectedItem) {
                                $('.drinks-dropdown > li[data-item = "' + selectedItem + '"]').css("background-color", "#e0e0e0");
                            } else {
                                $('.drinks-dropdown > li[data-item != "' + selectedItem + '"]').css("background-color", "rgba(0,0,0,0)");
                            }
                        });

                        //loop through each of the drink dropdown triggers
                        $('.drink-dropdown-trigger').each(function () {

                            setDrink(triggerSelector, cardSelector, this);

                        });
                    } else if ($(this).parent().hasClass('sides-dropdown')) {

                        //gets id of the card
                        var cardID = $(this).attr('id').split('-')[1];
                        var cardSelector = '#' + cardID;

                        //gets the value of the selected item and stores it in a variable
                        var selectedItem = $(this).attr('data-item');
                        if (typeof $(this).attr('data-price') !== "undefined") {
                            var selectedPrice = $(this).attr('data-price');
                        } else {
                            var selectedPrice = '';
                        }
                        var selectedCals = $(this).attr('data-calories');
                        var selectedText = '<span class="select-text-container"><span class="selected-side">' + selectedItem + '</span>' + ' | ' + selectedPrice + ' ' + selectedCals + '</span>';
                        var selectedValue = $(this).attr('data-item-value');
                        var selectedIsOption = $(this).attr('data-IsOption');
                        var selectedCookieId = $(this).attr('data-cookie-id');
                        var selectedCookieName = $(this).attr('data-cookie-name');

                        //finds value of dropdown trigger and sets it to whatever the selected item value is
                        var triggerSelector;
                        //if this is the second dropdown in a sides card
                        if (!($(this).parent().hasClass('dropdown-double'))) {
                            triggerSelector = '#trigger-' + cardID;
                            $(triggerSelector).html(selectedText);
                            $(triggerSelector).attr('data-selected-value', selectedValue);
                            $(triggerSelector).attr('aria-label', selectedItem + ' ' + selectedCals + ' Selected');
                            $(triggerSelector).attr('data-option-name', selectedItem); //optionValue
                            $(triggerSelector).attr('data-isoption', selectedIsOption); //IsOption
                            $(triggerSelector).attr('data-cookieid', selectedCookieId);
                            $(triggerSelector).attr('data-cookiename', selectedCookieName);
                            selectedArrayOneSide.splice(0, 1, selectedItem);
                            selectedArrayTwoSides = [];
                            selectedArrayThreeSides = [];
                            setTimeout(function () { $(triggerSelector).focus(); }, 100);
                            $('.selected-kind-name').html(selectedItem + '<span class="icon icon-expand_less desktop-exit"></span>');
                            $('.sides-dropdown li').each(function () {
                                if ($(this).data('item') == selectedItem) {
                                    $('.sides-dropdown > li[data-item = "' + selectedItem + '"]').css("background-color", "#e0e0e0");
                                } else {
                                    $('.sides-dropdown > li[data-item != "' + selectedItem + '"]').css("background-color", "rgba(0,0,0,0)");
                                }
                            });

                        } else if ($(this).parent().hasClass('dropdown-first')) {
                            triggerSelector = '#trigger-' + cardID;
                            $(triggerSelector).html(selectedText);
                            $(triggerSelector).attr('data-selected-value', selectedValue);
                            $(triggerSelector).attr('aria-label', selectedItem + ' ' + selectedCals + ' Selected');
                            $(triggerSelector).attr('data-option-name', selectedItem); //optionValue
                            $(triggerSelector).attr('data-isoption', selectedIsOption); //IsOption
                            $(triggerSelector).attr('data-cookieid', selectedCookieId);
                            $(triggerSelector).attr('data-cookiename', selectedCookieName);
                            selectedArrayTwoSides.splice(0, 1, selectedItem);
                            selectedArrayOneSide = [];
                            if (triggerSelector == '#trigger-sides2') {
                                setTimeout(function () { $('#trigger-sides2').focus(); }, 100);
                            }
                            $('.selected-first-cookie').html(selectedItem + '<span class="icon icon-expand_less desktop-exit"></span>');
                            $('.dropdown-first li').each(function () {
                                if ($(this).data('item') == selectedItem) {
                                    $('.dropdown-first > li[data-item = "' + selectedItem + '"]').css("background-color", "#e0e0e0");
                                } else {
                                    $('.dropdown-first > li[data-item != "' + selectedItem + '"]').css("background-color", "rgba(0,0,0,0)");
                                }
                            });
                        } else if (($(this).parent().hasClass('dropdown-second'))) {
                            selectedArrayThreeSides = [];
                            triggerSelector = '#trigger2-' + cardID;
                            $(triggerSelector).html(selectedText);
                            $(triggerSelector).attr('data-selected-value', selectedValue);
                            $(triggerSelector).attr('data-option-name', selectedItem); //optionValue
                            $(triggerSelector).attr('data-isoption', selectedIsOption); //IsOption
                            $(triggerSelector).attr('data-cookieid', selectedCookieId);
                            $(triggerSelector).attr('data-cookiename', selectedCookieName);
                            $(triggerSelector).attr('aria-label', selectedItem + ' ' + selectedCals + ' Selected');
                            selectedArrayThreeSides.splice(1, 1, selectedItem);
                            selectedArrayOneSide = [];
                            if (triggerSelector == '#trigger2-sides2') {
                                setTimeout(function () { $('#trigger2-sides2').focus(); }, 100);
                            }
                            $('.selected-second-cookie').html(selectedItem + '<span class="icon icon-expand_less desktop-exit"></span>');
                            $('.dropdown-second li').each(function () {
                                if ($(this).data('item') == selectedItem) {
                                    $('.dropdown-second > li[data-item = "' + selectedItem + '"]').css("background-color", "#e0e0e0");
                                } else {
                                    $('.dropdown-second > li[data-item != "' + selectedItem + '"]').css("background-color", "rgba(0,0,0,0)");
                                }
                            });
                        }

                        //hides list and overlay after an item is selected
                        $('.dragdealer, .overlay-time-list').addClass('hide-remove');
                        // setTimeout(function() { $(triggerSelector).focus(); }, 100);

                        //if it is a sides dropdown that isn't a double dropdown
                        if (!($(this).parent().hasClass('dropdown-double'))) {
                            //loop through each of the side dropdown triggers
                            $('.sides-dropdown-trigger').each(function () {

                                setSingleSide(triggerSelector, cardSelector, this);

                            });
                        }

                        //if the card has a double dropdown and only one item is selected
                        else if ($(this).parent().hasClass('dropdown-double') && selectedArrayTwoSides.length == 1) {
                            var triggerSelector = '#trigger-' + cardID;
                            var triggerSelector2 = '#trigger2-' + cardID;

                            //loop through each of the side dropdown triggers
                            $('.sides-dropdown-trigger').each(function () {

                                //remove any selected class from sides dropdown triggers hide any checkmark badges already showing
                                $('.sides-dropdown-trigger').removeClass('selected');
                                $('.badge-check-sides').addClass('hide-remove');
                                $(this).closest('.category-details').find('.category-image').removeClass('inactive');

                                //add selected class to the one that has selected item(s) and show checkmark badge on card
                                $(triggerSelector).addClass('selected');
                                $(triggerSelector2).addClass('selected');
                                $(this).closest('.category-details').find('.badge-check-sides').removeClass('hide-remove');
                                $('.sides-dropdown-trigger:not(.selected)').attr('data-selected-value', '');

                                //if the dropdown does not have a selected class, then make dropdown trigger return to default
                                if (!($(this).hasClass('selected'))) {
                                    var defaultText = $(this).attr('data-default');
                                    $(this).html(defaultText);
                                    $(this).attr('aria-label', defaultText);
                                    $(this).closest('.category-details').find('.category-image').addClass('inactive');
                                }

                            });
                        }


                        //if the card has a double dropdown and both items are selected
                        else if ($(this).parent().hasClass('dropdown-double') && selectedArrayTwoSides.length == 1 && selectedArrayThreeSides.length == 1) {
                            var triggerSelector = '#trigger-' + cardID;
                            var triggerSelector2 = '#trigger2-' + cardID;

                            //loop through each of the side dropdown triggers
                            $('.sides-dropdown-trigger').each(function () {
                                setTwoSides(triggerSelector, triggerSelector2, cardSelector, this);
                            });
                        }
                    }

                    //Remove disabled attribute from continue button in mobile if a drink is selected
                    if ($(window).width() < 1024) {
                        if ($('.meal-subtitle-sides, .meal-sides').is(':visible')) {
                            $('.btn-meal-continue').prop('disabled', true).attr('aria-disabled', 'true').addClass('hide-remove');
                            if ((selectedArrayOneSide.length === 1) || (selectedArrayTwoSides.length === 1 && selectedArrayThreeSides.length === 1)) {
                                $('.btn-meal-done').removeAttr('disabled').attr('aria-disabled', 'false').removeClass('hide-remove');
                            } else {
                                $('.btn-meal-done').prop('disabled', true).attr('aria-disabled', 'true');
                            }
                        } else {
                            $('.btn-meal-continue').removeAttr('disabled').attr('aria-disabled', 'false').removeClass('hide-remove');
                            $('.btn-meal-done').prop('disabled', true).attr('aria-disabled', 'true').addClass('hide-remove');
                        }
                    }

                    //Functionality to remove disabled attribute from the done button in desktop
                    if (((selectedArrayOneSide.length === 1) || (selectedArrayTwoSides.length === 1 && selectedArrayThreeSides.length === 1))) {
                        if ($(window).width() < 1024) {
                            if ($('.meal-subtitle-sides, .meal-sides').is(':visible')) {
                                $('.btn-meal-done').removeAttr('disabled').attr('aria-disabled', 'false').removeClass('hide-remove');
                            } else {
                                $('.btn-meal-done').prop('disabled', true).attr('aria-disabled', 'true').addClass('hide-remove');
                            }
                        } else {
                            $('.btn-meal-done').removeAttr('disabled').attr('aria-disabled', 'false').removeClass('hide-remove');
                        }
                    } else {
                        $('.btn-meal-done').prop('disabled', true).attr('aria-disabled', 'true');
                    }
                } else if (e.which === keyCodes.UP) {
                    //handle up key
                    e.preventDefault();
                    currentIndex = $(this).parent().children().index($(this))
                    if (currentIndex - 1 < 0) { } else {
                        $(this).parent().children()[currentIndex - 1].focus();
                    }


                } else if (e.which === keyCodes.DOWN) {
                    //handle down key
                    e.preventDefault();
                    currentIndex = $(this).parent().children().index($(this))
                    if (currentIndex + 1 >= $(this).parent().children().length) { } else {
                        $(this).parent().children()[currentIndex + 1].focus();
                    }
                } else if (e.which === keyCodes.TAB) {
                    //handle tab key
                    $('.dragdealer, .overlay-time-list, .expand-time-dropdown').addClass('hide-remove');
                }
            });
        });

        function toggleDropdown(selector, button) {
            if (isOpen(selector)) {
                $('.dragdealer, .overlay-time-list, .expand-time-dropdown').addClass('hide-remove');
            } else {
                //show dropdown list, overlay, and dropdown close button
                $('.overlay-time-list, .desktop-exit').removeClass('hide-remove');
                $(selector).removeClass('hide-remove');
                //add in tabindex = 0 so that li elements in open dropdown are tabbable
                $(selector).find('li').attr('tabindex', -1);
                $(button).attr('aria-expanded', true);
                $(selector).find('li').first().focus();
                //hide dropdown on blur after the last element has been tabbed through and set li tab index to -1 making items not tabbable
                    
            }

        }

        function setDrink(trigger, card, dropdown) {

            //remove any selected class from drink dropdown triggers hide any checkmark badges already showing
            $('.drink-dropdown-trigger').removeClass('selected');
            $('.badge-check-drinks').addClass('hide-remove');
            $(dropdown).closest('.category-details').find('.category-image').removeClass('inactive');

            //add selected class to the one that has selected item and show checkmark badge on card
            $(trigger).addClass('selected');
            $(card).find('.badge-check').removeClass('hide-remove');
            $('.drink-dropdown-trigger:not(.selected)').attr('data-selected-value', '');
            $('.meal-subtitle-sides, .meal-sides').removeClass('hide-remove');
            if ($('.badge-check-sides.hide-remove').length == 2) {
                $('.sides-grid').closest('.meal-sides').find('.category-details').css({ "height": "173px" });
                if ($(window).width() < 1024) { $('.sides-grid').closest('.meal-sides').find('.category-details').css({ "height": "152px" }); }
            }

            //if the dropdown does not have a selected class, then make dropdown trigger return to default
            if (!($(dropdown).hasClass('selected'))) {
                var defaultText = $(dropdown).attr('data-default');
                $(dropdown).html(defaultText);
                $(dropdown).attr('aria-label', defaultText);
                $(dropdown).closest('.category-details').find('.category-image').addClass('inactive');
                $(dropdown).closest('.category-details').css({ "height": "173px" });
                if ($(window).width() < 1024) { $(dropdown).closest('.category-details').css({ "height": "152px" }); }
            }
        }

        function setSingleSide(trigger, card, dropdown) {

            //remove any selected class from drink dropdown triggers hide any checkmark badges already showing
            $('.sides-dropdown-trigger').removeClass('selected');
            $('.badge-check-sides').addClass('hide-remove');
            $(dropdown).closest('.category-details').find('.category-image').removeClass('inactive');

            //add selected class to the one that has selected item and show checkmark badge on card
            $(trigger).addClass('selected');
            $(card).find('.badge-check').removeClass('hide-remove');
            $('.sides-dropdown-trigger:not(.selected)').attr('data-selected-value', '');


            //if the dropdown does not have a selected class, then make dropdown trigger return to default
            if (!($(dropdown).hasClass('selected'))) {
                var defaultText = $(dropdown).attr('data-default');
                $(dropdown).html(defaultText);
                $(dropdown).attr('aria-label', defaultText);
                $(dropdown).closest('.category-details').find('.category-image').addClass('inactive');
            }
        }

        function setTwoSides(trigger, trigger2, card, dropdown) {

            //remove any selected class from sides dropdown triggers hide any checkmark badges already showing
            $('.sides-dropdown-trigger').removeClass('selected');
            $('.badge-check-sides').addClass('hide-remove');
            $(dropdown).closest('.category-details').find('.category-image').removeClass('inactive');

            //add selected class to the one that has selected item(s) and show checkmark badge on card
            $(trigger).addClass('selected');
            $(trigger2).addClass('selected');
            $(card).find('.badge-check').removeClass('hide-remove');
            $('.sides-dropdown-trigger:not(.selected)').attr('data-selected-value', '');

            //if the dropdown does not have a selected class, then make dropdown trigger return to default
            if (!($(dropdown).hasClass('selected'))) {
                var defaultText = $(dropdown).attr('data-default');
                $(dropdown).html(defaultText);
                $(dropdown).attr('aria-label', defaultText);
                $(dropdown).closest('.category-details').find('.category-image').addClass('inactive');
            }
        }

        function setDrinksImage(imageID, dropdown) {
            //remove any selected class from drink dropdown triggers hide any checkmark badges already showing
            $('.drink-dropdown-trigger').removeClass('selected');
            $('.badge-check-drinks').addClass('hide-remove');
            $(dropdown).closest('.category-details').find('.category-image').removeClass('inactive');
            //if the dropdown does not have a selected class, then make dropdown trigger return to default
            if (($(dropdown).closest('.category-details').find('.badge-check').hasClass('hide-remove'))) {
                var defaultText = $(dropdown).closest('.category-details').find('.drink-dropdown-trigger').attr('data-default');
                var mealText = $(dropdown).closest('.category-details').find('.meal-category').text();
                $(dropdown).closest('.category-details').find('.drink-dropdown-trigger').html(defaultText);
                $(dropdown).closest('.category-details').find('.drink-dropdown-trigger').attr('aria-label', defaultText);
                $(dropdown).closest('.category-details').find('.category-image').attr('aria-label', mealText);
                $(dropdown).closest('.category-details').find('.img-container').attr('aria-label', mealText);
                $(dropdown).closest('.category-details').find('.category-image').addClass('inactive');
                $(dropdown).closest('.category-details').find('.pickup-info').addClass('hide-remove');
                $(dropdown).closest('.category-details').css({ "height": "173px" });
                if ($(window).width() < 1024) { $(dropdown).closest('.category-details').css({ "height": "152px" }); }

            }
            $(imageID).closest('.category-details').find('.badge-check').removeClass('hide-remove');
            $(imageID).closest('.category-details').find('.category-image').removeClass('inactive');
            $(imageID).closest('.category-details').find('.pickup-info').removeClass('hide-remove');
            $(imageID).closest('.category-details').css({ "height": "242px" });
            if ($(window).width() < 1024) { $(imageID).closest('.category-details').css({ "height": "215px" }); }
            var defaultText = $(imageID).closest('.category-details').find('.meal-category').text();
            $(imageID).closest('.category-details').find('.category-image').attr('aria-label', defaultText + ' Selected');
            $(imageID).closest('.category-details').find('.img-container').attr('aria-label', defaultText + ' Selected');
            $(this).focus();
        }

        $('.time-list-trigger').off('click');

        //click on image trigger
        $('.drinks-image').on('click keydown', function (e) {
            $('#SelectedDrink').val('');
            var textSelectKind = $('#SelectKind').val();
            $('.selected-item-name').html(textSelectKind + '<span class="icon icon-expand_less expand-time-dropdown hide-remove"></span><span class="icon icon-expand_less desktop-exit hide-remove"></span>');
            $('.drinks-dropdown li').each(function () {
                $('.drinks-dropdown > li').css("background-color", "rgba(0,0,0,0)");
            });
            $("#MakeItMealSides").css('display', 'none');
            if (e.which === keyCodes.RETURN || e.type === 'click') {
                //use trigger id to find id of parent card
                var imageID = '#' + $(this).attr('id');
                $(imageID).closest('.category-details').find('.pickup-info').removeClass('hide-remove');
                $(imageID).closest('.category-details').find('.badge-check').removeClass('hide-remove');
                $('.drinks-image').each(function () {
                    setDrinksImage(imageID, this);
                });
                selectedArrayOneDrink = [];
                setTimeout(function () {
                    var drinksVal = $(imageID).closest('.category-details').find('.sides-dropdown-trigger').text();
                    if (drinksVal === '') {
                        if ($(window).width() < 1024) {
                            $('.btn-meal-done').prop('disabled', true).attr('aria-disabled', 'true').addClass('hide-remove');
                            $('.btn-meal-continue').prop('disabled', true).attr('aria-disabled', 'true').removeClass('hide-remove');
                        } else {
                            $('.btn-meal-done').prop('disabled', true).attr('aria-disabled', 'true').removeClass('hide-remove');
                            $('.btn-meal-continue').prop('disabled', true).attr('aria-disabled', 'true').addClass('hide-remove')
                        }
                    }
                }, 10);
            }
        });

        function setSideImage(imageID, dropdown) {
            //remove any selected class from drink dropdown triggers hide any checkmark badges already showing
            $('.sides-dropdown-trigger').removeClass('selected');
            $('.badge-check-sides').addClass('hide-remove');
            $(dropdown).closest('.category-details').find('.category-image').removeClass('inactive');
            //if the dropdown does not have a selected class, then make dropdown trigger return to default
            if (($(dropdown).closest('.category-details').find('.badge-check').hasClass('hide-remove'))) {
                var defaultText = $(dropdown).closest('.category-details').find('.sides-dropdown-trigger').attr('data-default');
                var defaultText1 = $(dropdown).closest('.category-details').find('.sides-dropdown-trigger2').attr('data-default');
                var mealText = $(dropdown).closest('.category-details').find('.meal-category').text();
                $(dropdown).closest('.category-details').find('.sides-dropdown-trigger').html(defaultText);
                $(dropdown).closest('.category-details').find('.sides-dropdown-trigger').attr('aria-label', defaultText);
                $(dropdown).closest('.category-details').find('.sides-dropdown-trigger2').html(defaultText1);
                $(dropdown).closest('.category-details').find('.sides-dropdown-trigger2').attr('aria-label', defaultText1);
                $(dropdown).closest('.category-details').find('.category-image').attr('aria-label', mealText);
                $(dropdown).closest('.category-details').find('.img-container').attr('aria-label', mealText);
                $(dropdown).closest('.category-details').find('.category-image').addClass('inactive');
                $(dropdown).closest('.category-details').find('.pickup-info').addClass('hide-remove');
                $(dropdown).closest('.category-details').css({ "height": "173px" });
                if ($(window).width() < 1024) { $(dropdown).closest('.category-details').css({ "height": "152px" }); }
            }
            $(imageID).closest('.category-details').find('.badge-check').removeClass('hide-remove');
            $(imageID).closest('.category-details').find('.category-image').removeClass('inactive');
            $(imageID).closest('.category-details').find('.pickup-info').removeClass('hide-remove');
            $(imageID).closest('.category-details').css({ "height": "242px" });
            if ($(window).width() < 1024) { $(imageID).closest('.category-details').css({ "height": "215px" }); }
            var defaultText = $(imageID).closest('.category-details').find('.meal-category').text();
            $(imageID).closest('.category-details').find('.category-image').attr('aria-label', defaultText + ' Selected');
            $(imageID).closest('.category-details').find('.img-container').attr('aria-label', defaultText + ' Selected');
            $(this).focus();
            if (imageID == '#image-sides2') {
                $(imageID).closest('.category-details').css({ "height": "295px" });
                if ($(window).width() < 1024) { $(imageID).closest('.category-details').css({ "height": "275px" }); }
            }
        }

        $('.sides-image').on('click keydown', function (e) {
            $('.sides-dropdown li').each(function () {
                $('.sides-dropdown > li').css("background-color", "rgba(0,0,0,0)");
            });
            if (e.which === keyCodes.RETURN || e.type === 'click') {
                //use trigger id to find id of parent card
                var imageID = '#' + $(this).attr('id');
                var sidesVal = $(imageID).closest('.category-details').find('.sides-dropdown-trigger').text();
                var textSelectKind = $('#SelectKind').val();
                setTimeout(function () {
                    if (sidesVal === 'Select First Cookie Select Second Cookie' || sidesVal === 'Select First Cookie Select First Cookie' || sidesVal === textSelectKind || sidesVal === 'Sélectionner le 1er biscuit Sélectionner le 2e biscuit') {
                    $('.btn-meal-done').prop('disabled', true);
                    $('.btn-meal-done').attr('aria-disabled', 'true');
                    $('.selected-kind-name').html(textSelectKind + '<span class="icon icon-expand_less expand-time-dropdown hide-remove"></span><span class="icon icon-expand_less desktop-exit hide-remove"></span>');
					$('.selected-first-cookie').html('Select First Cookie<span class="icon icon-expand_less expand-time-dropdown hide-remove"></span><span class="icon icon-expand_less desktop-exit hide-remove"></span>');
					$('.selected-second-cookie').html('Select Second Cookie<span class="icon icon-expand_less expand-time-dropdown hide-remove"></span><span class="icon icon-expand_less desktop-exit hide-remove"></span>');
					$('.sides-dropdown > li').each(function() {
                    $('.sides-dropdown > li').css("background-color","rgba(0,0,0,0)");
					});
                }
             }, 10);
            $(imageID).closest('.category-details').find('.pickup-info').removeClass('hide-remove');
            $(imageID).closest('.category-details').find('.badge-check').removeClass('hide-remove');
            $('.sides-image').each(function() {
                setSideImage(imageID,this);
            });
            selectedArrayTwoSides = [];
            selectedArrayThreeSides = [];
            }
        });

        $('.sides-image, .drinks-image').on('mouseenter focus', function () {
            //use trigger id to find id of parent card
            var imageID = '#' + $(this).attr('id');
            var imageActive = $(imageID).closest('.category-details').find('.category-image').hasClass('inactive');
            if (imageActive) {
                $(imageID).closest('.category-details').find('.category-image').removeClass('inactive');
            }
        });
        $('.sides-image').on('mouseleave blur', function () {
            //use trigger id to find id of parent card
            var imageID = '#' + $(this).attr('id');
            var imageActive = $(imageID).closest('.category-details').find('.category-image').hasClass('inactive');
            var btnSelect = $(imageID).closest('.category-details').find('.drink-dropdown-trigger').hasClass('selected');
            var btnActive = $(imageID).closest('.category-details').find('.pickup-info').hasClass('hide-remove');
            var badgeSelect = $(imageID).closest('.category-details').find('.badge-check.hide-remove').length;
            if ($("div.category-image.inactive").length > 0 && $(imageID).closest('.category-details').find('.badge-check.hide-remove').length != 1 || $('#image-sides1').closest('.category-details').find('.badge-check.hide-remove').length <= 0 || $('#image-sides2').closest('.category-details').find('.badge-check.hide-remove').length <= 0) {
                if (btnSelect == false && btnActive == true) {
                    $(imageID).closest('.category-details').find('.category-image').addClass('inactive');
                }
            }
        });
        $('.drinks-image').on('mouseleave blur', function () {
            //use trigger id to find id of parent card
            var imageID = '#' + $(this).attr('id');
            var imageActive = $(imageID).closest('.category-details').find('.category-image').hasClass('inactive');
            var btnSelect = $(imageID).closest('.category-details').find('.drink-dropdown-trigger').hasClass('selected');
            var btnActive = $(imageID).closest('.category-details').find('.pickup-info').hasClass('hide-remove');
            var badgeSelect = $(imageID).closest('.category-details').find('.badge-check.hide-remove').length;
            if ($("div.category-image.inactive").length > 0 || $("div.badge-check.hide-remove").length <= 3) {
                if (btnSelect == false && btnActive == true) {
                    $(imageID).closest('.category-details').find('.category-image').addClass('inactive');
                }
            }
        });


        //click on dropdown trigger
        $('.time-list-trigger').on('click', function () {

            //use trigger id to find id of parent card
            var triggerID = $(this).attr('id');
            var cardID = $(this).attr('id').split('-')[1];


            //if this is the second dropdown in the card has id trigger2-(card ID)
            if ($(this).hasClass('sides-dropdown-trigger2')) {

                //find id of dropdown list associated with that card and trigger
                var dropdownSelector = '#dropdown2-' + cardID;

                //show dropdown list, overlay, and dropdown close button
                toggleDropdown(dropdownSelector, this);

            } else if (!($(this).hasClass('sides-dropdown-trigger2'))) {
                //find id of dropdown list associated with that card and trigger
                var dropdownSelector = '#dropdown-' + cardID;

                //show dropdown list, overlay, and dropdown close button
                toggleDropdown(dropdownSelector, this);
            }


            //clicking on exit up arrow on will close the dropdown
            $('.desktop-exit, .fixed-li').on('click', function () {
                $('.dragdealer, .overlay-time-list').addClass('hide-remove');
            });
        });

        //click on icon trigger
        $('.icon-expand_more').on('click', function () {

            //use trigger id to find id of parent card
            var triggerID = '#' + $(this).closest('.category-details').find('.time-list-trigger').attr('id');
            var cardID = $(this).closest('.category-details').find('.time-list-trigger').attr('id').split('-')[1];
            var dropdownID = '#' + $(this).closest('.category-details').find('.dragdealer').eq(1).attr('id');
            var dropdownID1 = '#' + $(this).closest('.category-details').find('.dragdealer').eq(0).attr('id');

            if (!($(this).closest('.category-details').find('.time-list-trigger').hasClass('sides-dropdown-trigger2')) || dropdownID1 == '#dropdown-sides2') {
                //find id of dropdown list associated with that card and trigger
                var dropdownSelector = '#dropdown-' + cardID;

                //show dropdown list, overlay, and dropdown close button
                toggleDropdown(dropdownSelector, this);
            }


            //clicking on exit up arrow on will close the dropdown
            $('.desktop-exit, .fixed-li').on('click', function () {
                $('.dragdealer, .overlay-time-list').addClass('hide-remove');
            });
        });

        //click on icon trigger
        $('.icon-expand_more1').on('click', function () {

            //use trigger id to find id of parent card
            var triggerID = '#' + $(this).closest('.category-details').find('.time-list-trigger').attr('id');
            var cardID = $(this).closest('.category-details').find('.time-list-trigger').attr('id').split('-')[1];
            var dropdownID = '#' + $(this).closest('.category-details').find('.dragdealer').eq(1).attr('id');
            var dropdownID1 = '#' + $(this).closest('.category-details').find('.dragdealer').eq(0).attr('id');


            //if this is the second dropdown in the card has id trigger2-(card ID)
            if ($(this).closest('.meal-dropdown').find('.time-list-trigger').hasClass('sides-dropdown-trigger2')) {

                //find id of dropdown list associated with that card and trigger
                var dropdownSelector = '#dropdown2-' + cardID;

                //show dropdown list, overlay, and dropdown close button
                toggleDropdown(dropdownSelector, this);

            }

            //clicking on exit up arrow on will close the dropdown
            $('.desktop-exit, .fixed-li').on('click', function () {
                $('.dragdealer, .overlay-time-list').addClass('hide-remove');
            });
        });

        $('.draggable-list li').off('click');

        // returns a string display based on item name, price, and calories
        function getDropdownDisplay(element) {
            var selectedItem = element.attr('data-item');
            var selectedPrice = element.attr('data-price');
            var selectedCalories = element.attr('data-calories');
            if (selectedPrice) {
                selectedPrice = ' | ' + selectedPrice;
            } else {
                selectedPrice = '';
            }
            return selectedItem + selectedPrice + ' | ' + selectedCalories;
        }

        //click on list item


        $('.btn-meal-continue').on('click', function () {
            $(this).addClass('hide-remove');
            if ((selectedArrayOneSide.length === 1) || (selectedArrayTwoSides.length === 1 && selectedArrayThreeSides.length === 1)) {
                $('.btn-meal-done').removeAttr('disabled').attr('aria-disabled', 'false').removeClass('hide-remove');
            } else {
                $('.btn-meal-done').prop('disabled', true).attr('aria-disabled', 'true').removeClass('hide-remove');
            }
            $('.meal-subtitle-drinks, .meal-drinks').hide();
            $('.meal-subtitle-sides, .meal-sides').show();
            setTimeout(function () {
                setHeight();
            }, 100);
            window.history.pushState('', null, window.location.href + '/#');
        });

        $('.overlay-time-list').off('click');

        //Clicking on overlay will hide the pullup list and overlay
        $('.overlay-time-list').on('click', function () {
            $('.dragdealer, .overlay-time-list, .expand-time-dropdown').addClass('hide-remove');
        });
        
        var txt = $('.selected-item-name').text();

        //Preselect Drink and sides if navigated to from the checkout page
        if ($('#SelectedDrink').length && $('#SelectedDrink').val() && txt=='Select KindSelect Kind' ) {
            var drinkValue = $('#SelectedDrink').attr('value');
            var drinkName = $('.drinks-dropdown').find("[data-item-value='" + drinkValue + "']").attr('data-item');
            var drinkTrigger = $('.drinks-dropdown').find("[data-item-value='" + drinkValue + "']").closest('.dragdealer').parent().find('.drink-dropdown-trigger');
            $(drinkTrigger).html(drinkName);

            var cardIdInit = $('.drinks-dropdown').find("[data-item-value='" + drinkValue + "']").attr('id').split('-')[1];
            var cardSelector = '#' + cardIdInit;
            var cardSelectorInit = '#trigger-' + cardIdInit;
            var cardSelectorDrinks = '#image-' + cardIdInit;

            $(cardSelectorInit).attr('data-selected-value', drinkValue);
            $(cardSelectorDrinks + ' div').parent().find('div').removeClass("hide-remove");
            selectedArrayOneDrink.splice(0, 1, drinkName);

            //gets the value of the selected item and stores it in a variable
            if (typeof $(this).attr('data-price') !== "undefined") {
                var selectedPrice = $(this).attr('data-price');
            } else {
                var selectedPrice = '';
            }
            var selectedCals = $('.drinks-dropdown').find("[data-item-value='" + drinkValue + "']").attr('data-calories');
            var selectedText = '<span class="select-text-container"><span class="selected-drink">' + drinkName + '</span>' + ' | ' + selectedPrice + ' ' + selectedCals + '</span>';

            //finds value of dropdown trigger and sets it to whatever the selected item value is
            $(cardSelectorInit).html(selectedText);
            $(cardSelectorInit).attr('aria-label', selectedText + ' Selected');

            $('.drink-dropdown-trigger').each(function () {
                setDrink(cardSelectorInit, cardSelector, this);
            });

            var dropItemValue = $('.drinks-dropdown').find("[data-item-value='" + drinkValue + "']");
            var selectedItem = dropItemValue.attr('data-item');
            var selectedIsOption = dropItemValue.attr('data-IsOption');
            var selectedChoiceId = dropItemValue.attr('data-choice-id');
            var selectedCookieId = $(this).attr('data-cookie-id');
            var selectedCookieName = $(this).attr('data-cookie-name');
            var triggerSelector = '#' + $('.drink-dropdown-trigger.selected').attr('id');
            $(triggerSelector).attr('data-selected-value', drinkValue); //optionId
            $(triggerSelector).attr('aria-label', drinkValue + ' ' + selectedCals + ' Selected');
            $(triggerSelector).attr('data-option-name', selectedItem); //optionValue
            $(triggerSelector).attr('data-isoption', selectedIsOption); //IsOption
            $(triggerSelector).attr('data-choiceid', selectedChoiceId); //choiceId
            $(triggerSelector).attr('data-cookieid', selectedCookieId);
            $(triggerSelector).attr('data-cookiename', selectedCookieName);

            //hides list and overlay after an item is selected
            $('.dragdealer, .overlay-time-list').addClass('hide-remove');
            setTimeout(function () { $(cardSelectorInit).focus(); }, 100);
            $('.draggable-list li').off('click');
        }

        if ($('#SelectedSide1').length && $('#SelectedSide1').val() && !($('#SelectedSide2').length && $('#SelectedSide2').val())) {
            var sideValue = $('#SelectedSide1').attr('value');
            var sideName = $('.sides-dropdown').find("[data-item-value='" + sideValue + "']").attr('data-item');
            var sideTrigger = $('.sides-dropdown').find("[data-item-value='" + sideValue + "']").closest('.dragdealer').parent().find('.sides-dropdown-trigger');
            $(sideTrigger).html(sideName);
            if (sideName !== undefined) {
                var cardIdInit = $('.sides-dropdown').find("[data-item-value='" + sideValue + "']").attr('id').split('-')[1];
                var cardSelectorInit = '#trigger-' + cardIdInit;
                var cardSelectorSides = '#image-' + cardIdInit;

                $('.sides-dropdown-trigger').each(function () {

                    setSingleSide(sideTrigger, cardSelectorInit, this);

                });
                $(cardSelectorInit).attr('data-selected-value', sideValue);
                $(cardSelectorSides + ' div').parent().find('div').removeClass("hide-remove");
                var side1Dropdown = $('.sides-dropdown').find("[data-item-value='" + sideValue + "']");
                triggerSelector = cardSelectorInit;
                $(triggerSelector).attr('data-option-name', sideName); //optionValue
                $(triggerSelector).attr('data-isoption', side1Dropdown.attr('data-isoption')); //IsOption
                selectedArrayOneSide.splice(0, 1, sideName);
                selectedArrayTwoSides = [];
                selectedArrayThreeSides = [];
            }
        }

        if ($('#SelectedSide1').length && $('#SelectedSide1').val() && $('#SelectedSide2').length && $('#SelectedSide2').val()) {
            var sideValue1 = $('#SelectedSide1').attr('value');
            var sideName1 = $('.sides-dropdown').find("[data-item-value='" + sideValue1 + "']").attr('data-item');
            var cookieId1 = $('.sides-dropdown').find("[data-item-value='" + sideValue1 + "']").attr('data-cookie-id');
            var cookieName1 = $('.sides-dropdown').find("[data-item-value='" + sideValue1 + "']").attr('data-cookie-name');
            var sideTrigger = $('.sides-dropdown').find("[data-item-value='" + sideValue1 + "']").closest('.dragdealer').parent().find('.sides-dropdown-trigger');
            var sideTrigger1 = $(sideTrigger[0]);
            var sideTrigger2 = $(sideTrigger[1]);
            var sideValue2 = $('#SelectedSide2').attr('value');
            var sideName2 = $('.sides-dropdown').find("[data-item-value='" + sideValue2 + "']").attr('data-item');
            var cookieId2 = $('.sides-dropdown').find("[data-item-value='" + sideValue2 + "']").attr('data-cookie-id');
            var cookieName2 = $('.sides-dropdown').find("[data-item-value='" + sideValue2 + "']").attr('data-cookie-name');
            $(sideTrigger1).html(cookieId1);
            $(sideTrigger1).html(cookieName1);
            $(sideTrigger1).html(sideName1);
            $(sideTrigger2).html(cookieId2);
            $(sideTrigger2).html(cookieName2);
            $(sideTrigger2).html(sideName2);
            var cardIdInit = $('.sides-dropdown').find("[data-item-value='" + sideValue1 + "']").attr('id').split('-')[1];
            var cardSelectorInit1 = '#trigger-' + cardIdInit;
            var cardSelectorInit2 = '#trigger2-' + cardIdInit;
            var cardSelectorSides = '#image-' + cardIdInit;

            $('.sides-dropdown-trigger').each(function () {

                setTwoSides(sideTrigger1, sideTrigger2, cardSelectorInit, this);

            });
            $(cardSelectorInit1).attr('data-selected-value', sideValue1);
            $(cardSelectorInit1).attr('data-option-name', sideName1);
            $(cardSelectorInit1).attr('data-cookieid', cookieId1);
            $(cardSelectorInit1).attr('data-cookiename', cookieName1);
            $(cardSelectorInit2).attr('data-selected-value', sideValue2);
            $(cardSelectorInit2).attr('data-option-name', sideName2);
            $(cardSelectorInit2).attr('data-cookieid', cookieId2);
            $(cardSelectorInit2).attr('data-cookiename', cookieName2);
            $(cardSelectorSides + ' div').parent().find('div').removeClass("hide-remove");
            selectedArrayTwoSides.splice(0, 1, sideName1);
            selectedArrayThreeSides.splice(0, 1, sideName2);
        }

        //Functionality to remove disabled attribute from the done button in desktop (Edit Mode)
        if (selectedArrayOneDrink.length === 1 && ((selectedArrayOneSide.length === 1) || (selectedArrayTwoSides.length === 1 && selectedArrayThreeSides.length === 1))) {
            if ($(window).width() < 1024) {
                if ($('.meal-subtitle-sides, .meal-sides').is(':visible')) {
                    $('.btn-meal-done').removeAttr('disabled').attr('aria-disabled', 'false').removeClass('hide-remove');
                } else {
                    $('.btn-meal-continue').removeAttr('disabled').attr('aria-disabled', 'false').removeClass('hide-remove');
                    $('.btn-meal-done').prop('disabled', true).attr('aria-disabled', 'true').addClass('hide-remove');
                }
            } else {
                $('.btn-meal-done').removeAttr('disabled').attr('aria-disabled', 'false').removeClass('hide-remove');
            }
        } else {
            $('.btn-meal-done').prop('disabled', true).attr('aria-disabled', 'true').addClass('hide-remove');
        }

        //If a user resizes the page from mobile to desktop, the drinks and cookies will both be shown
        var resizeTimer;

        $(window).resize(function (e) {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                // applies generically to all items with sticky class
                mobileView();
                setHeight();
            }, 500);
        });

        function mobileView() {
            if ($(window).width() > 1023) {
                $('.meal-subtitle-drinks, .meal-drinks').show();
                $('.meal-subtitle-sides, .meal-sides').show();
                $('.btn-meal-continue').hide();
            } else {
                $('.btn-meal-continue').show();
            }
        }
        //call it once on page load
        (mobileView());
    }

    if (window.history && window.history.pushState && $(window).width() < 1024) {
        $(window).on('popstate', function () {
            if ($('.meal-subtitle-sides, .meal-sides').is(':visible')) {
                $('#backLinkUrl').attr('href', '#');
                $('.meal-subtitle-drinks, .meal-drinks').show();
                $('.meal-subtitle-sides, .meal-sides').hide();
                $('.btn-meal-done').prop('disabled', true).attr('aria-disabled', 'true').addClass('hide-remove');
                $('.btn-meal-continue').removeAttr('disabled').attr('aria-disabled', 'false').removeClass('hide-remove');
                setTimeout(function () {
                    setHeight();
                }, 100);
            }
        });
    }



    function pageActions() {
        makeItAMealInit();

        $('.btn-meal-done').click(function () {
            orderViewModel.OrderSourceType = analytics.orderSourceType.regularCart;
            analytics.OrderSourceType(orderViewModel.OrderSourceType);
            // do nothing if the link is not enabled

            modalShowId('#MakeAMealModalCart');


        });
        $('#Addextrameal').click(function () {
            if ($(this).hasClass('inactive')) {
                return false;
            }
            $('#subway-spinner').show();
            orderViewModel.deleteCombos();


            //Drinks could be more than 2 in length (20oz, 21oz, Bottle) so we'll dynamically grab the id of the selected drink - Assumption is made that there can only be one selected
            var drinksSelector = '#trigger-' + $('.meal-drinks .sides-grid .drinks-image:not(.inactive)').parents('li').attr('id');

            var drinksValue = $(drinksSelector).attr('data-selected-value');

            var sides1Value = $('#trigger-sides1').attr('data-selected-value');
            var sides2Value = $('#trigger-sides2').attr('data-selected-value');
            var sides2Value2 = $('#trigger2-sides2').attr('data-selected-value');

            // if for some reason, they manage to submit the form without two cookies, duplicate the first cookie
            if (!sides2Value2) {
                sides2Value2 = sides2Value;
            }

            var comboId = $('#ComboId').val();
            var comboName = $('#ComboName').val();
            var comboValue = $('#ComboValue').val();
            orderViewModel.initCombo(comboId, comboName, comboValue);

            // add drinks option
            var productid = "";
            var productName = "";
            var optionid = "";
            var optionName = "";
            if (drinksValue) {
                optionid = $(drinksSelector).attr('data-combo-option-id');
                optionName = $(drinksSelector).attr('data-option-name');
                var isOption = $(drinksSelector).attr('data-isoption');
                if (isOption === 'True') {
                    productid = $(drinksSelector).attr('data-choiceid');
                    productName = $(drinksSelector).attr('data-combo-option-name');
                }
                void 0;
                orderViewModel.addComboOption(optionid, drinksValue, 1, optionName, productid, productName);
            }
            else {
                void 0;
            }

            // add either chips or 2 cookies
            if (sides1Value) {
                optionid = $('#trigger-sides1').attr('data-combo-option-id');
                optionName = $('#trigger-sides1').attr('data-option-name');
                productid = "";
                productName = "";
                orderViewModel.addComboOption(optionid, sides1Value, 1, optionName, productid, productName);
            }
            else if (sides2Value && sides2Value2) {
                optionid = $('#trigger-sides2').attr('data-combo-option-id');
                var optionName1 = $('#trigger-sides2').attr('data-option-name');
                var optionName2 = $('#trigger2-sides2').attr('data-option-name');
                productid = $('#trigger-sides2').attr('data-cookieid');
                productName = $('#trigger-sides2').attr('data-cookiename');
                orderViewModel.addComboOption(optionid, sides2Value, 1, optionName1, productid, productName);
                orderViewModel.addComboOption(optionid, sides2Value2, 1, optionName2, productid, productName);
            }
            else {
                void 0;
            }

            orderViewModel.save();

            // hidden field for referrer will indicate where you originated from.
            // if referrer was the AddToCart button from product details page, need to add the item to cart directly then go to the Order Management Page.
            // otherwise, need to redirect back to the Product details page.
            var referrer = $('#Referrer').val();

            // if no referrer, go back to product details page
            if (!referrer) {

                // the current URL will contain all the informaton you need to get back to the product detail page.
                var currentUrl = window.location.href;
                var splitUrl = currentUrl.split("make-it-a-meal");

                if (splitUrl.length === 2) {
                    void 0;
                    window.location.href = splitUrl[0];
                }
                else {
                    void 0;
                }
            }
            // else if referrer is the AddToCart button from Product Details page, go to OM page.
            else if (referrer === 'AddToBag') {
                addToCartnew();
            }
            else if (referrer === 'order-management') {
                updateCartItem();
            }
            else if (referrer === 'AddToCustomBag') {
                addToCustomCart();
            }
        });



        $('#MealCheckout').click(function () {

            if ($(this).hasClass('inactive')) {
                return false;
            }
            $('#subway-spinner').show();
            orderViewModel.deleteCombos();


            //Drinks could be more than 2 in length (20oz, 21oz, Bottle) so we'll dynamically grab the id of the selected drink - Assumption is made that there can only be one selected
            var drinksSelector = '#trigger-' + $('.meal-drinks .sides-grid .drinks-image:not(.inactive)').parents('li').attr('id');

            var drinksValue = $(drinksSelector).attr('data-selected-value');

            var sides1Value = $('#trigger-sides1').attr('data-selected-value');
            var sides2Value = $('#trigger-sides2').attr('data-selected-value');
            var sides2Value2 = $('#trigger2-sides2').attr('data-selected-value');

            // if for some reason, they manage to submit the form without two cookies, duplicate the first cookie
            if (!sides2Value2) {
                sides2Value2 = sides2Value;
            }

            var comboId = $('#ComboId').val();
            var comboName = $('#ComboName').val();
            var comboValue = $('#ComboValue').val();
            orderViewModel.initCombo(comboId, comboName, comboValue);

            // add drinks option
            var productid = "";
            var productName = "";
            var optionid = "";
            var optionName = "";
            if (drinksValue) {
                optionid = $(drinksSelector).attr('data-combo-option-id');
                optionName = $(drinksSelector).attr('data-option-name');
                var isOption = $(drinksSelector).attr('data-isoption');
                if (isOption === 'True') {
                    productid = $(drinksSelector).attr('data-choiceid');
                    productName = $(drinksSelector).attr('data-combo-option-name');
                }
                void 0;
                orderViewModel.addComboOption(optionid, drinksValue, 1, optionName, productid, productName);
            }
            else {
                void 0;
            }

            // add either chips or 2 cookies
            if (sides1Value) {
                optionid = $('#trigger-sides1').attr('data-combo-option-id');
                optionName = $('#trigger-sides1').attr('data-option-name');
                productid = "";
                productName = "";
                orderViewModel.addComboOption(optionid, sides1Value, 1, optionName, productid, productName);
            }
            else if (sides2Value && sides2Value2) {
                optionid = $('#trigger-sides2').attr('data-combo-option-id');
                var optionName1 = $('#trigger-sides2').attr('data-option-name');
                var optionName2 = $('#trigger2-sides2').attr('data-option-name');
                productid = "";
                productName = "";
                orderViewModel.addComboOption(optionid, sides2Value, 1, optionName1, productid, productName);
                orderViewModel.addComboOption(optionid, sides2Value2, 1, optionName2, productid, productName);
            }
            else {
                void 0;
            }

            orderViewModel.save();

            // hidden field for referrer will indicate where you originated from.
            // if referrer was the AddToCart button from product details page, need to add the item to cart directly then go to the Order Management Page.
            // otherwise, need to redirect back to the Product details page.
            var referrer = $('#Referrer').val();

            // if no referrer, go back to product details page
            if (!referrer) {

                // the current URL will contain all the informaton you need to get back to the product detail page.
                var currentUrl = window.location.href;
                var splitUrl = currentUrl.split("make-it-a-meal");

                if (splitUrl.length === 2) {
                    void 0;
                    window.location.href = splitUrl[0];
                }
                else {
                    void 0;
                }
            }
            // else if referrer is the AddToCart button from Product Details page, go to OM page.
            else if (referrer === 'AddToBag') {
                addToCart();
            }
            else if (referrer === 'order-management') {
                updateCartItem();
            }
            else if (referrer === 'AddToCustomBag') {
                addToCustomCart();
            }


        });
        var addToCartnew = function () {
            var productId = $('#APIProductId').val();
            var storeId = $("input[name=RestaurantId]").val();
            var addItemRoute = $('#frmAddItem').attr('action');

            var model = {
                CartId: orderViewModel.currentOrder.cartId,
                StoreId: storeId,
                ProductId: productId
            };

            var combo = null;

            if (orderViewModel.hasCombo()) {
                combo = orderViewModel.combo;
            }

            if (combo) {
                model.Combo = combo;
            }

            model.UpsellIngredients = orderViewModel.currentOrder.product.options;

            $.ajax({
                url: addItemRoute,
                type: 'POST',
                data: model,
                success: function (response) {
                    // first check for any error returned even when method returned success
                    if (response.Error) {
                        modalClose(false);
                        var errorModel = subwayScript.ParseJsonOrDefault(response.Error.Message);
                        void 0;
                    }
                    else {
                        var comboPrice = parseFloat($('#ComboPrice').val());
                        var comboId = $('#ComboId').val();
                        var basePrice = parseFloat($('#itemComboBasePrice').val());
                        $('.time-list-trigger')
                            .each(function () {
                                var price = $(this).attr('data-price');
                                if (price) {
                                    var priceDigits = price.match(/\d+\.\d+/)[0];
                                    if (priceDigits) {
                                        var addPrice = parseFloat(priceDigits);
                                        basePrice += addPrice;
                                    }
                                }
                            });

                       
                        var countmeal = $('#cart').text();
                        if (countmeal === "") {
                            countmeal = 0;
                        }
                        countmeal++;

                        //Analytics Updation
                        analytics.makeitameal(productId, basePrice, comboId, comboPrice);

                        // delete combos after adding to cart so next product will not have the same combo
                        orderViewModel.deleteCombos();
                        orderViewModel.currentOrder.cartId = response.CartId;
                        orderViewModel.currentOrder.cartQuantity = countmeal;
                        orderViewModel.clearProductOptions();
                        orderViewModel.Analytics.isFooterMIAMSelected = false;
                        orderViewModel.Analytics.isMiamYesButtonClicked = false;
                        orderViewModel.save();

                        window.location.href = subwayScript.navigation.getMenuUrl(orderViewModel.store.id);
                    }
                    $('#subway-spinner').hide();
                },
                error: function (jqXhr) {
                    modalClose(false);
                    $('#subway-spinner').hide();
                    subwayScript.showAjaxError(jqXhr);

                }
            });
        }

        var addToCustomCart = function () {
            var productId = orderViewModel.customizerModel.ProductId;
            var quantity = orderViewModel.customizerModel.Quantity;
            var options = orderViewModel.customizerModel.Options;
            var cartId = orderViewModel.customizerModel.CartId;
            var storeId = orderViewModel.customizerModel.StoreId;
            var addItemRoute = $('#frmAddNewItem').attr('action');

            var model = {
                CartId: orderViewModel.currentOrder.cartId,
                StoreId: storeId,
                ProductId: productId,
                Quantity: quantity,
                Options: options
            };

            var combo = null;

            if (orderViewModel.hasCombo()) {
                combo = orderViewModel.combo;
            }

            if (combo) {
                model.Combo = combo;
            }

            model.UpsellIngredients = orderViewModel.currentOrder.product.options;

            $.ajax({
                url: addItemRoute,
                type: 'POST',
                data: model,
                success: function (response) {
                    // first check for any error returned even when method returned success
                    if (response.Error) {
                        modalClose(false);
                        var errorModel = subwayScript.ParseJsonOrDefault(response.Error.Message);
                        void 0;
                    }
                    else {
                        var comboPrice = parseFloat($('#ComboPrice').val());
                        var comboId = $('#ComboId').val();
                        var basePrice = parseFloat($('#itemComboBasePrice').val());
                        $('.time-list-trigger')
                            .each(function () {
                                var price = $(this).attr('data-price');
                                if (price) {
                                    var priceDigits = price.match(/\d+\.\d+/)[0];
                                    if (priceDigits) {
                                        var addPrice = parseFloat(priceDigits);
                                        basePrice += addPrice;
                                    }
                                }
                            });

                        analytics.addItemToBag("", productId, basePrice);
                        //Analytics Updation
                        analytics.makeitameal("", productId, basePrice, comboId, comboPrice);
                        // delete combos after adding to cart so next product will not have the same combo
                        orderViewModel.deleteCombos();
                        orderViewModel.currentOrder.cartId = response.CartId;
                        orderViewModel.currentOrder.cartQuantity = response.CartQuantity;
                        orderViewModel.Analytics.isMiamFromCustomizer = false;
                        orderViewModel.Analytics.isExtrasFromCustomizer = false;
                        orderViewModel.clearProductOptions();
                        orderViewModel.save();
                        window.location.replace(response.SuccessUrl);
                    }
                    $('#subway-spinner').hide();
                },
                error: function (jqXhr) {
                    modalClose(false);
                    $('#subway-spinner').hide();
                    subwayScript.showAjaxError(jqXhr);

                }
            });
        }

        var addToCart = function () {
            var productId = $('#APIProductId').val();
            var storeId = $("input[name=RestaurantId]").val();
            var addItemRoute = $('#frmAddItem').attr('action');

            var model = {
                CartId: orderViewModel.currentOrder.cartId,
                StoreId: storeId,
                ProductId: productId
            };

            var combo = null;

            if (orderViewModel.hasCombo()) {
                combo = orderViewModel.combo;
            }

            if (combo) {
                model.Combo = combo;
            }

            model.UpsellIngredients = orderViewModel.currentOrder.product.options;

            $.ajax({
                url: addItemRoute,
                type: 'POST',
                data: model,
                success: function (response) {
                    // first check for any error returned even when method returned success
                    if (response.Error) {
                        modalClose(false);
                        var errorModel = subwayScript.ParseJsonOrDefault(response.Error.Message);
                        void 0;
                    }
                    else {
                        var comboPrice = parseFloat($('#ComboPrice').val());
                        var comboId = $('#ComboId').val();
                        var basePrice = parseFloat($('#itemComboBasePrice').val());
                        $('.time-list-trigger')
                            .each(function () {
                                var price = $(this).attr('data-price');
                                if (price) {
                                    var priceDigits = price.match(/\d+\.\d+/)[0];
                                    if (priceDigits) {
                                        var addPrice = parseFloat(priceDigits);
                                        basePrice += addPrice;
                                    }
                                }
                            });

                        //Analytics Updation
                        analytics.makeitameal(productId, basePrice, comboId, comboPrice);

                        // delete combos after adding to cart so next product will not have the same combo
                        orderViewModel.deleteCombos();
                        orderViewModel.currentOrder.cartId = response.CartId;
                        orderViewModel.currentOrder.cartQuantity = response.CartQuantity;
                        orderViewModel.clearProductOptions();
                        orderViewModel.Analytics.isFooterMIAMSelected = false;
                        orderViewModel.Analytics.isMiamYesButtonClicked = false;
                        orderViewModel.save();

                        window.location.replace(response.SuccessUrl);
                    }
                    $('#subway-spinner').hide();
                },
                error: function (jqXhr) {
                    modalClose(false);
                    $('#subway-spinner').hide();
                    subwayScript.showAjaxError(jqXhr);

                }
            });
        }

        var updateCartItem = function () {
            var productId = $('#APIProductId').val();
            var basePrice = parseFloat($('#itemComboBasePrice').val());
            var cartItemId = $('#CartItemId').val();
            var updateItemRoute = $('#frmUpdateItem').attr('action');
            var productName = $('#ProductName').val();

            var model = {
                CartId: orderViewModel.currentOrder.cartId,
                CartItemId: cartItemId,
                ProductId: productId,
                Quantity: 1,
                ProductName: productName,
                PassThroughOptions: true  // we don't have access to the item's currently selected options from the MIAM page, so we'll indicate they should be retrieved and passed through.
            };

            var combo = null;

            if (orderViewModel.hasCombo()) {
                combo = orderViewModel.combo;
            }

            if (combo) {
                model.Combo = combo;
            }

            $.ajax({
                url: updateItemRoute,
                type: 'POST',
                data: model,
                success: function (response) {
                    // first check for any error returned even when method returned success
                    if (response.Error) {
                        modalClose(false);
                        var errorModel = subwayScript.ParseJsonOrDefault(response.Error.Message);
                        void 0;
                    }
                    else {
                        var comboPrice = parseFloat($('#ComboPrice').val());
                        var comboId = $('#ComboId').val();
                        orderViewModel.Analytics.isMiamFromCart = true;
                        orderViewModel.save();
                        //Analytics Updation
                        analytics.makeitameal(productId, basePrice, comboId, comboPrice);

                        // delete combos after adding to cart so next product will not have the same combo
                        orderViewModel.deleteCombos();
                        orderViewModel.currentOrder.cartId = response.CartId;
                        orderViewModel.Analytics.isMiamFromCart = false;
                        orderViewModel.save();

                        window.location.replace(subwayScript.navigation.getOrderManagementUrl());
                    }
                    $('#subway-spinner').hide();
                },
                error: function (jqXhr) {
                    modalClose(false);
                    $('#subway-spinner').hide();
                    subwayScript.showAjaxError(jqXhr);

                }
            });
        }
    }
    function setHeight() {
        $(".category-details").css("height", "0px");
        $(".category-details").each(function () {
            var categoryContentHeight = $(this).find('.category-image').height() + $(this).find('.category-content').height();
            if ($(this).find('button').hasClass("selected") || (!$(this).find('.category-image').hasClass("inactive") && ($(".badge-check-sides").is(":visible")) && $(window).width() < 1024)) {
                categoryContentHeight += 14;
            }
            $(this).css("height", categoryContentHeight + 'px');
        });
    }

    $(function () {
        makeItAMealInit();
    });
}